<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{
          Object.entries(this.data).length === 0 ? "HIRE NEW" : "UPDATE"
        }}
        PERSON
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- JOB TITLE -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <span style="font-size: 90%">Person</span>

            <v-select
              autocomplete
              :options="data_options_person"
              v-model="dataPerson"
            />
          </div>

          <div class="vx-col w-full mt-4">


          <span style="font-size: 90%" 
              >Birthday</span
            >
            <datepicker
              label="Birthday" 
              v-model="dataBirthday"
              name="birthday"
            ></datepicker>
          </div>

          <div class="vx-col w-full">
            <vs-input
              label="Job title"
              v-model="dataJobTitle"
              class="mt-4 w-full"
              name="jobtitle"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('jobtitle')">{{
              errors.first("jobtitle")
            }}</span>
          </div>
          <div class="vx-col w-full">
            <vs-input
              label="SAGA Code"
              v-model="dataSagaCode"
              class="mt-4 w-full"
              name="sagacode"
            />
            <span class="text-danger text-sm" v-show="errors.has('jobtitle')">{{
              errors.first("jobtitle")
            }}</span>
          </div>
          <div class="vx-col w-full">
            <vs-input
              label="Contract Name"
              v-model="dataContractName"
              class="mt-4 w-full"
              name="contract"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('contract')">{{
              errors.first("contract")
            }}</span>
          </div>


          <div class="vx-col w-full" v-if="isadmin">
            <vs-input
              label="Net Salary (RON)"
              v-model="dataNetSalary"
              class="mt-4 w-full"
              name="netsalary"
              v-validate="'decimal'"
            />
            <span class="text-danger text-sm" v-show="errors.has('netsalary')">{{
              errors.first("netsalary")
            }}</span>
          </div>


          <div class="vx-col w-full mt-4">
            <span style="font-size: 90%">Start Date</span>
            <datepicker  label="Start Date" name="datestart" v-model="dataStartDate" v-validate="'required'"></datepicker>
            <span
              class="text-danger text-sm"
              v-show="errors.has('datestart')"
              >{{ errors.first("datestart") }}</span
            >
          </div>
          <div class="vx-col w-full mt-4">
            <div
              v-if="dataIsPermanent"
              @click="changePermanent"
              class="
                btn-add-new
                p-3
                mb-4
                mr-4
                rounded-lg
                cursor-pointer
                flex
                items-center
                justify-center
                text-lg
                font-medium
                text-base text-primary
                border border-solid border-primary
              "
            >
              <feather-icon icon="ClockIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary"
                >Permanent contract</span
              >
            </div>
            <div
              v-if="!dataIsPermanent"
              @click="changePermanent"
              class="
                btn-add-new
                p-3
                mb-4
                mr-4
                rounded-lg
                cursor-pointer
                flex
                items-center
                justify-center
                text-lg
                font-medium
                text-base text-alert
                border border-solid border-alert
              "
            >
              <feather-icon icon="ClockIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-secondary"
                >Fixed-term contract</span
              >
            </div>
            <span style="font-size: 90%" v-if="!dataIsPermanent"
              >Stop Date</span
            >
            <datepicker
              label="Start Date" 
              v-if="!dataIsPermanent"
              v-model="dataStopDate"
              v-validate="'required'"
              name="datestop"
            ></datepicker>
            <span
              class="text-danger text-sm"
              v-if="!dataIsPermanent"
              v-show="errors.has('datestop')"
              >{{ errors.first("datestop") }}</span
            >
          </div>
          <div class="vx-col w-full">
            <vs-input
              label="PIN CODE (let empty to not edit)"
              v-model="dataPinCode"
              class="mt-5 w-full"
              name="pincode"
              v-validate="'numeric'"
              style="background-color:#FFFACD"
            />
            <span class="text-danger text-sm" v-show="errors.has('pincode')">{{
              errors.first("pincode")
            }}</span>
          </div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>
 
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "@/axios.js";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      isadmin : false,
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    Datepicker,
    "v-select": vSelect,
  },
  data() {
    return {
      dataIsPermanent: true,
      dataSagaCode: "",
      dataNetSalary: null,
      dataBirthday: "",
      data_options_person: [],
      dataId: null,
      dataPerson: "",
      dataJobTitle: "",
      dataContractName: "",
      dataStartDate: "",
      dataPinCode:null,
      dataStopDate: "",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    isSidebarActive(val) {
      this.getOptionsPerson();
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
        this.dataId = null;
      } else {
        const { id, jobtitle, contractname, datestart, datestop, idperson , net_salary , birthday,sagacode } =
          JSON.parse(JSON.stringify(this.data));
        this.dataId = id;
        this.dataJobTitle = jobtitle;
        this.dataContractName = contractname;
        this.dataStartDate = datestart;
        this.dataStopDate = datestop;
        this.dataBirthday = birthday;
        this.dataSagaCode = sagacode
        this.dataNetSalary = net_salary;
        if (this.dataStopDate) this.dataIsPermanent = false;
        else this.dataIsPermanent = true;

        const ItemIndex = this.data_options_person.findIndex(
          (p) => p.value === idperson
        );
        this.dataPerson = this.data_options_person.splice(ItemIndex, 1);
      }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          /*this.$validator.reset()
           this.initValues()*/
        }
      },
    },
    isFormValid() {
      return !this.errors.any();
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    changePermanent() {
      if (this.dataIsPermanent) this.dataIsPermanent = false;
      else this.dataIsPermanent = true;
    },
    async getOptionsPerson() {
      axios.get("/people_name/data").then((response) => {
        this.data_options_person = [...response.data];
      });
    },
    initValues() {
      (this.data_options_person = []),
        (this.dataPerson = ""),
        (this.dataJobTitle = ""),
        (this.dataNetSalary = ""),
        (this.dataBirthday = ""),
        (this.dataContractName = ""),
        (this.dataStartDate = ""),
        (this.dataStopDate = ""),
        (this.dataSagaCode = ""),
        (this.dataPinCode = ""),
        (this.dataIsPermanent = false);
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var stopdate = null;
          if (!this.dataIsPermanent)
            stopdate = moment(this.dataStopDate).add(1, 'day').format("YYYY-MM-DD")
          if (!this.dataStopDate) stopdate = null;
          let idperson = null;
          if (this.dataPerson.value) idperson = this.dataPerson.value;
          else idperson = this.dataPerson[0].value;

          let salary = 0;
          let birthday = null;
          if (this.dataNetSalary) salary = this.dataNetSalary;
          if (this.dataBirthday) birthday = moment(this.dataBirthday).add(1, 'day').format("YYYY-MM-DD")
          let obj = {}
          if (this.dataPinCode)
          {
            obj = {
            id: this.dataId,
            jobtitle: this.dataJobTitle,
            datestart: moment(this.dataStartDate).add(1, 'day').format("YYYY-MM-DD"),
            datestop: stopdate,
            name: this.dataContractName,
            idperson: idperson,
            sagacode: this.dataSagaCode,
            pincode: this.dataPinCode,
            net_salary : salary,
            birthday:birthday
          };
          }
          else { obj = {
            id: this.dataId,
            jobtitle: this.dataJobTitle,
            datestart: moment(this.dataStartDate).add(1, 'day').format("YYYY-MM-DD"),
            datestop: stopdate,
            name: this.dataContractName,
            sagacode: this.dataSagaCode,
            idperson: idperson,
            net_salary : salary,
            birthday: birthday

          };
          }
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store
              .dispatch("dataListEmployee/updateItem", obj)
              .catch((err) => {
                console.error(err);
              });
            this.$vs.notify({
              color: "success",
              title: "Contract Updated!",
              text: "The Contract was successfully edited",
            });
            this.$emit("closeSidebar");
            this.initValues();
          } else {
            delete obj.id;
            this.$store
              .dispatch("dataListEmployee/createItem", obj)
              .catch((err) => {
                console.error(err);
              });
            this.$vs.notify({
              color: "success",
              title: "Contract Created!",
              text: "The Contract was successfully added",
            });
            this.$emit("closeSidebar");
            this.initValues();
          }
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) this.isadmin = true
    this.getOptionsPerson();
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
